var v4_customData={};
try {
    v4_customData={
      currency: ShopifyAnalytics.meta.currency,
      pageType: ShopifyAnalytics.meta.page.pageType
    };
    Shopify.analytics.publish("sce_page_init", v4_customData); 
  } catch (error) {};
window.dataLayer = window.dataLayer || [];
$(function () {
 var GAiiv = function isInView(o) {
          typeof o[0] === 'undefined' ? o = o : o = o[0];
          if (o instanceof HTMLElement) {
              var vph = window.innerHeight, wpw = window.innerWidth;
              var oRect = o.getBoundingClientRect();
              var ott = oRect.top + oRect.height * 0.5;
              var otl = oRect.left + oRect.width * 0.5;
              return (ott > 0 && ott < vph && otl > 0 && otl < wpw);
          } else { return false; }
 }
      var GAgdb = function gaDebounce(fn, wait) {
          var timeout = null;
          return function () {
              if (timeout !== null) { clearTimeout(timeout); }
              timeout = setTimeout(fn, wait);
          }
 }
  // Header Click
  jQuery("#jw-pc-header a").each(function(){
	$(this).on('click',function(){
		var label = $(this).attr("href").replace("/","").trim();
		if(!label){
			label ="logo";
		}else{
          if(label.includes("apps")){
            label ="17TRACK";
          }
          if(label.includes("whatsapp")){
            label ="whatsapp"
          }
        }
		dataLayer.push({	        
          "event_category": pagegrounp,
          "event_action": "click",
          "event_label": label,
	        "event": "cme_top_nav"
    	});
	})
})
// Header Search
  jQuery("#shopify-section-header .site-header__search-btn .icon-search").on('click',function(){
	var text = $(this).parent().siblings(".site-header__search-input").val();
	dataLayer.push({	        
		    "event_category": pagegrounp,
          	"event_action": "search",
          	"event_label": text,
	        "event": "cme_search"
   		 });
})
jQuery("#shopify-section-header .site-header__search-input").keyup(function(e){
	if(e.keyCode === 13){    
		dataLayer.push({	        
		    "event_category": pagegrounp,
          	"event_action": "search",
          	"event_label": $(this).val(),
	        "event": "cme_search",
   		 });
	}                                            
})
jQuery("#shopify-section-header .hot-search-list li").each(function(){
	var label = $(this).find("a").text().trim();
	$(this).on('click',function(){
		dataLayer.push({	        
		    "event_category": pagegrounp,
	        "event_action": "hot search",
	        "event_label": label,
	        "event": "cme_search"
   		 });
	})
})
  // Mobile Menu SVG
  jQuery("#jw-pc-header .js-drawer-open-nav").on('click',function(){
		dataLayer.push({	        
		    "event_category": pagegrounp,
	        "event_action": "click",
	        "event_label": "Mobile Menu Button",
	        "event": "cme_top_nav"
   		 });
})
  // PC Menu
  jQuery("#jw-pc-header").next().find(".site-navigation>li").each(function(){
	$(this).find(".site-nav__dropdown-link").each(function(){
				$(this).on('click',function(e){
					e.stopPropagation();
					var label = $(this).text().trim();	
                  label = label.replace("🎁","").trim();
					dataLayer.push({
						"event_category": pagegrounp,
          				"event_action": "click",
                 	"event_label": "L2::"+label,
				        "event": "cme_top_menu"
			    	});
				})
	})
	$(this).on('click',function(){
		var label = $(this).children("a").text().replace("🎄","").trim();		
		dataLayer.push({
			"event_category": pagegrounp,
          	"event_action": "click",
         	"event_label": "L1::"+label,
	        "event": "cme_top_menu"
    	});
	})
})
  // Mobile Menu
  $("#NavDrawer ul.mobile-nav").on("click","a.mobile-nav__link",function(){
	var label =$(this).text().trim();
	if($(this).hasClass("mobile-nav__link--top-level")){
      label = label.replace("🎄","").trim();
		label = "L1::"+label;
	}else{
      if(label.includes("Log in")){
        label = "Log in";
      }else{
        label = label.replace("🎁","").trim();
		label = "L2::"+label;
      }
	}
	dataLayer.push({  
		"event_category":pagegrounp,
		"event_action": "click",
	    "event_label": label,
	    "event": "cme_top_menu"
	})
})
   $("#NavDrawer ul.mobile-nav__social").on("click","a",function(){
     var label =$(this).find(".icon__fallback-text").text().trim();
     dataLayer.push({  
		"event_category":pagegrounp,
		"event_action": "click",
	    "event_label": "Mobmenu::"+label,
	    "event": "cme_top_menu"
	})
   }) 
    $("#NavDrawer ul.track-order-item").on("click","a",function(){
     dataLayer.push({  
		"event_category":pagegrounp,
		"event_action": "click",
	    "event_label": "Mobmenu::Track Your Order",
	    "event": "cme_top_menu"
	})
   }) 
  // Slide Bottom
  $(".homeContainer-sales_con").on("click","a.homeContainer-sales_item",function(){
	var label = $(this).find(".home-category_info").text().trim();
	dataLayer.push({
		"event_categoty":"home_page",
		"event_action": "menu_click",
	    "event_label": label,
	    "event": "cme_category_click"
	})
})
  // view more
  jQuery("#MainContent div[data-section-type='collection-template']").each(function(){
	var action = $(this).find("h2.section-header__title .tit-new").text().trim();
    action = action.replace("⚡","").trim();
    action = action.replace("⚡","").trim();
	var label = $(this).find("a.section-header__link,a.shop_flexY").text().trim();
	$(this).find("a.shop_flexY").on('click',function(){
		dataLayer.push({
			"event_categoty":"home_page",
			"event_action": action+"_click",
		    "event_label": label,
		    "event": "cme_click"
		})
	})	
})
  //Homepage Four Img
    $(".homepage-imglist-container .homeContainer-sales_container").on("click","a.homeContainer-sales_items",function(){
     var label =$(this).attr("title").trim();
     dataLayer.push({  
		"event_category":pagegrounp,
		"event_action": "img_click",
	    "event_label": label+"-img-"+$(this).index(),
	    "event": "cme_imgad_click"
	})
   }) 
  // Home Keyword Click
  $(".home-keywords-container .jw-custom-text-keyword").on("click","a",function(){
     var label =$(this).text().trim();
     dataLayer.push({  
		"event_category":pagegrounp,
		"event_action": "keyword_click",
	    "event_label": label,
	    "event": "cme_keyword_click"
	})
   }) 
    // footer link
  jQuery("#shopify-section-footer .site-footer__linklist").each(function(){
	var label = $(this).parents(".collapsible-content.collapsible-content--small").siblings("p").text().trim();
	$(this).find("li>a").on('click',function(){
		dataLayer.push({	        
		    "event_category": pagegrounp,
          	"event_action": "click",
        	"event_label": label+"::"+$(this).text().trim(),
	        "event": "cme_footer_nav"
   		 });
	})
})
  // Footer Social
    $("footer.site-footer .grid__item .icon-container ul.footer__social").on("click","a",function(){
     var label =$(this).find(".icon__fallback-text").text().trim();
     dataLayer.push({  
		"event_category":pagegrounp,
		"event_action": "footer social",
	    "event_label": "footer::"+label,
	    "event": "cme_footer_social"
	})
   }) 
      function sendSwiperClickdata(idselect,index){
                   $(idselect).eq(index).each(function(){
                           var imgitems=new Array();
                           var csl=index;
                            var iid = "homepage_swiper-slide-banner_image";
                            var pid = "homepage_swiper-slide-banner_image";
                           var cnm = $(this).find("img").attr("src");
                            var pnm = $(this).find("img").attr("alt");
                          imgitems.push({
                               "item_id": iid,
                               "item_name": pnm,
                               "promotion_id": pid,
                               "promotion_name": pnm,
                               "creative_name": cnm,
                               "creative_slot": csl
                            });
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_select_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
                  })
  }
    function sendSwiperViewdata(idselect,index){
                   $(idselect).eq(index).each(function(){
                           var imgitems=new Array();
                           var csl=index;
                            var iid = "homepage_swiper-slide-banner_image";
                            var pid = "homepage_swiper-slide-banner_image";
                           var cnm = $(this).find("img").attr("src");
                            var pnm = $(this).find("img").attr("alt");
                          imgitems.push({
                               "item_id": iid,
                               "item_name": pnm,
                               "promotion_id": pid,
                               "promotion_name": pnm,
                               "creative_name": cnm,
                               "creative_slot": csl
                            });
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_view_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
                  })
  }
  // swiper slide
  var pcflag = {};
  var pcswiper = new Swiper('#pcSwiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  autoplay: {
		delay: 5000,
		disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable:true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on:{
      slideChangeTransitionEnd:function(event){
        var pcswiperCon = document.getElementById("pcSwiper");
        if(GAiiv(pcswiperCon)){
         var img_index = this.realIndex;
          var infoSelection = "#swiper-ga4-pushinfo .slide-content-p";
          if(pcflag[img_index] !== img_index){
            sendSwiperViewdata(infoSelection,img_index);
            pcflag[img_index] = img_index;
          }    
        }
      }
    }
})
 // swiper pc click
  $("#pcSwiper .swiper-slide").click(function(){
    var indexReal = pcswiper.realIndex;
    var infoSelection = "#swiper-ga4-pushinfo .slide-content-p";
    sendSwiperClickdata(infoSelection,indexReal);
})
     var mobflag = {};
  var mobswiper = new Swiper('#mySwiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable:true,
  }, 
  loop: true,
  autoplay: {
		delay: 5000,
		disableOnInteraction: false,
  },
  on:{
      slideChangeTransitionEnd:function(event){
        var mobswiperCon = document.getElementById("mySwiper");
        if(GAiiv(mobswiperCon)){
         var img_index = this.realIndex;
          var infoSelection = "#swiper-ga4-pushinfo .slide-content-p";
          if(mobflag[img_index] !== img_index){
            sendSwiperViewdata(infoSelection,img_index);
            mobflag[img_index] = img_index;
          }    
        }
      }
    }
})
  // swiper mobile click
  $("#mySwiper .swiper-slide").click(function(){
    var indexReal = mobswiper.realIndex;
    var infoSelection = "#swiper-ga4-pushinfo .slide-content-p";
    sendSwiperClickdata(infoSelection,indexReal);
})
})
$(function () {
var visibleCount = 8;
var expandSize = 8;
    if($(document).width() < 750){
      expandSize = 6;
    }
  var moreUrl=$("#recom-list-container").attr("data-more-url");
  $("#loadMorebtn").click(function(){
       const productElements = $("#recom-list-container .grid .grid__item");
       const nextVisibleCount = visibleCount + expandSize;
       // console.log("****"+nextVisibleCount);
       showProducts(visibleCount, nextVisibleCount);
       visibleCount = nextVisibleCount;
       if (visibleCount >= productElements.length) {
          $("#loadMorebtn").html('<a class="featured-collection__expand-more featured-collection__expand-more--blank" href="'+moreUrl+'"><span>VIEW ALL</span><svg class="mec-icon featured-collection__expand-more__icon" aria-hidden="true"><use xlink:href="#mec-a-gengduojiantou"></use></svg></a>');
       }
  })
   // 显示指定范围内的产品
    function showProducts(start, end) {
      const productElements = $("#recom-list-container .grid .grid__item");
        for (let i = start; i < end && i < productElements.length; i++) {
            productElements.eq(i).addClass('visible-item');
        }
    }
})
 $(function(){
       $(".coll-tab-header .coll-sw_btn").click(function(){
          $(this).addClass("active").siblings().removeClass("active");
          var clickindex = $(this).index();
           $(this).parents(".coll-tab-header").next(".coll-tab-content").find(".tab-text-list").hide();
          $(this).parents(".coll-tab-header").next(".coll-tab-content").find(".tab-text-list").eq(clickindex).show();
       })
 });
// $(function () {
//   var moreUrl=$("#tabpro-recom0").attr("data-more-url");
//   const $products = $('#tabpro-recom0 .grid .grid__item');
//             let shown = 8; // 初始显示数量
//             let isLoading = false;
//   $(window).scroll(function() {
//                 // 排除重复加载和已加载完成的情况
//                 if (isLoading || shown >= $products.length) return;

//                 // 计算滚动位置
//                 const scrollTop = $(window).scrollTop();
//                 const windowHeight = $(window).height();
//                 const documentHeight = $(document).height();
                
//                 // 当滚动到离底部200px时触发
//                 if (scrollTop + windowHeight >= documentHeight - 200) {
//                     isLoading = true;
//                        // 显示下4个产品
//                   $products.slice(shown, shown + 4).fadeIn(500);
//                         shown += 4;
//                         isLoading = false;
//                 }
//            if (shown >= $products.length) {
//                $("#loadMorebtn0").html('<a class="featured-collection__expand-more featured-collection__expand-more--blank" href="'+moreUrl+'"><span>VIEW ALL</span><svg class="mec-icon featured-collection__expand-more__icon" aria-hidden="true"><use xlink:href="#mec-a-gengduojiantou"></use></svg></a>');
//              }
//             });
  
// })
// $(function () {
//       var GAiiv = function isInView(o) {
//           typeof o[0] === 'undefined' ? o = o : o = o[0];
//           if (o instanceof HTMLElement) {
//               var vph = window.innerHeight, wpw = window.innerWidth;
//               var oRect = o.getBoundingClientRect();
//               var ott = oRect.top + oRect.height * 0.5;
//               var otl = oRect.left + oRect.width * 0.5;
//               return (ott > 0 && ott < vph && otl > 0 && otl < wpw);
//           } else { return false; }
//  }

//   // 配置参数
//             const config = {
//                 initialShow: 8,
//                 batchSize: 4,
//                 rowCapacity: 4,
//                 triggerThreshold: 0.5 // 触发比例
//             };

//             // 初始化变量
//             const $container = $('#tabpro-recom0');
//             const $scrollContainer = $('#tabpro-recom0 .grid');
//             const $products = $('#tabpro-recom0 .grid .grid__item');
//             let shownCount = 0;
//             let productHeight = 0;
//             let isLoading = false;
//   $(window).scroll(function() {
//     if(GAiiv($($scrollContainer))){
//       // 获取第一个产品高度
//                 productHeight = $products.first().outerHeight(true);
                        
//                 shownCount = config.initialShow;
//                 if (isLoading || shownCount >= $products.length) return;

//                 // 计算滚动信息
//                 const scrollTop = $scrollContainer.scrollTop();
//                 const containerHeight = $scrollContainer.innerHeight();
//                 const totalHeight = $container.outerHeight();

//                 // 计算当前可见的最后一行位置
//                 const visibleEnd = scrollTop + containerHeight;
                
//                 // 计算下一个触发点：已显示行数 + 0.5行
//                 const triggerLine = Math.floor(shownCount / config.rowCapacity) + config.triggerThreshold;
//                 const triggerPosition = triggerLine * productHeight;

//                 // if (visibleEnd >= triggerPosition) {
//                 //     loadMore();
//                 // }
//           // console.log("nihao***"+shownCount+"---"+productHeight);
//     }     
//   })
    // // 加载更多产品
    //         function loadMore() {
    //             isLoading = true;
                
    //             // 显示新批次
    //             $products.slice(shownCount, shownCount + config.batchSize)
    //                 .fadeIn(300, function() {
    //                     // 动画完成后更新状态
    //                     shownCount += config.batchSize;
    //                     isLoading = false;
                        
    //                     // 自动扩展容器高度
    //                     $container.height(shownCount / config.rowCapacity * productHeight);
    //                 });
    //         }
// })
// 方案一
// $(function () {
//   var moreUrl=$("#tabpro-recom0").attr("data-more-url");
//   const $products = $('#tabpro-recom0 .grid .grid__item');
//   const totalProducts = $products.length;
//   let currentPage = 1;
//   const perPage = 8;
//   let isLoading = false;
//   let shown = 8; // 初始显示数量
//   $(window).scroll(function() {
//     // 节流处理
//     if (isLoading) return;

//     // 获取推荐板块位置
//     const $recommendSection = $('#tabpro-recom0 .grid');
//     const sectionTop = $recommendSection.offset().top;
//     const sectionBottom = sectionTop + $recommendSection.outerHeight();
    
//     // 获取滚动位置
//     const scrollTop = $(window).scrollTop();
//     const windowHeight = $(window).height();
//     const scrollBottom = scrollTop + windowHeight;

//     // 判断是否进入推荐板块区域
//     if (scrollBottom > sectionTop && scrollTop < sectionBottom) {
//       // 判断是否滚动到底部
//       const tolerance = 100; // 提前100px加载
//       if (scrollBottom + tolerance >= sectionBottom) {
//         loadMoreProducts();
//         shown += 8;
//       }
//     }
//     if (shown >= totalProducts) {
//         $("#loadMorebtn0").html('<a class="featured-collection__expand-more featured-collection__expand-more--blank" href="'+moreUrl+'"><span>VIEW ALL</span><svg class="mec-icon featured-collection__expand-more__icon" aria-hidden="true"><use xlink:href="#mec-a-gengduojiantou"></use></svg></a>');
//      }
//   });
//   function loadMoreProducts() {
//     const loadedCount = currentPage * perPage;
//     if (loadedCount >= totalProducts) return;
//     isLoading = true;
//       $products.slice(loadedCount, loadedCount + perPage).fadeIn(500);
//       currentPage++;
//       isLoading = false;
//   }
//     // 节流函数
//   function throttle(fn, delay) {
//     let lastCall = 0;
//     return function(...args) {
//       const now = Date.now();
//       if (now - lastCall < delay) return;
//       lastCall = now;
//       fn.apply(this, args);
//     }
//   }
// })
// 方案2
$(function () {
    // 初始化变量
  var moreUrl=$("#tabpro-recom0").attr("data-more-url");
  const $window = $(window);
  const $section = $('#tabpro-recom0');
  const $container = $('#tabpro-recom0 .grid');
  const $products = $('#tabpro-recom0 .grid .grid__item');
  
  let currentIndex = 0;
  const totalProducts = $products.length;
  const initialShow = 8;
  const perShow = 4;
  let isLoading = false;
  currentIndex = initialShow;
    // 滚动事件监听（节流处理）
  $window.on('scroll', throttle(function() {
    if (isLoading || currentIndex >= totalProducts) return;

    // 获取推荐板块位置
    const sectionTop = $section.offset().top;
    const sectionHeight = $section.outerHeight();
    const sectionBottom = sectionTop + sectionHeight;

    // 获取视口位置
    const scrollTop = $window.scrollTop();
    const windowHeight = $window.height();
    const windowBottom = scrollTop + windowHeight;

    // 判断是否进入推荐板块区域
    const isInSection = windowBottom > sectionTop && scrollTop < sectionBottom;

    // 触发显示条件
    if (isInSection && (windowBottom + 100 >= sectionBottom)) {
      showProducts(perShow);
    }
  }, 200));

  // 显示产品函数
  function showProducts(count) {
    isLoading = true;

    // 模拟加载效果
    setTimeout(() => {
      const remaining = totalProducts - currentIndex;
      const showCount = Math.min(count, remaining);

      // 显示对应产品
      $products.slice(currentIndex, currentIndex + showCount).fadeIn(400);
      
      currentIndex += showCount;
      isLoading = false;

      // 全部显示完成
      if (currentIndex >= totalProducts) {
        $("#loadMorebtn0").html('<a class="featured-collection__expand-more featured-collection__expand-more--blank" href="'+moreUrl+'"><span>VIEW ALL</span><svg class="mec-icon featured-collection__expand-more__icon" aria-hidden="true"><use xlink:href="#mec-a-gengduojiantou"></use></svg></a>');
      }
    }, 300);
  }

  // 节流函数
  function throttle(fn, delay) {
    let lastCall = 0;
    return function(...args) {
      const now = Date.now();
      if (now - lastCall < delay) return;
      lastCall = now;
      fn.apply(this, args);
    }
  }
})
// tab2
$(function () {
    // 初始化变量
  var moreUrl=$("#tabpro-recom1").attr("data-more-url");
  const $window = $(window);
  const $section = $('#tabpro-recom1');
  const $container = $('#tabpro-recom1 .grid');
  const $products = $('#tabpro-recom1 .grid .grid__item');
  
  let currentIndex = 0;
  const totalProducts = $products.length;
  const initialShow = 8;
  const perShow = 4;
  let isLoading = false;
  currentIndex = initialShow;
    // 滚动事件监听（节流处理）
  $window.on('scroll', throttle(function() {
    if (isLoading || currentIndex >= totalProducts) return;

    // 获取推荐板块位置
    const sectionTop = $section.offset().top;
    const sectionHeight = $section.outerHeight();
    const sectionBottom = sectionTop + sectionHeight;

    // 获取视口位置
    const scrollTop = $window.scrollTop();
    const windowHeight = $window.height();
    const windowBottom = scrollTop + windowHeight;

    // 判断是否进入推荐板块区域
    const isInSection = windowBottom > sectionTop && scrollTop < sectionBottom;

    // 触发显示条件
    if (isInSection && (windowBottom + 100 >= sectionBottom)) {
      showProducts(perShow);
    }
  }, 200));

  // 显示产品函数
  function showProducts(count) {
    isLoading = true;

    // 模拟加载效果
    setTimeout(() => {
      const remaining = totalProducts - currentIndex;
      const showCount = Math.min(count, remaining);

      // 显示对应产品
      $products.slice(currentIndex, currentIndex + showCount).fadeIn(400);
      
      currentIndex += showCount;
      isLoading = false;

      // 全部显示完成
      if (currentIndex >= totalProducts) {
        $("#loadMorebtn1").html('<a class="featured-collection__expand-more featured-collection__expand-more--blank" href="'+moreUrl+'"><span>VIEW ALL</span><svg class="mec-icon featured-collection__expand-more__icon" aria-hidden="true"><use xlink:href="#mec-a-gengduojiantou"></use></svg></a>');
      }
    }, 300);
  }

  // 节流函数
  function throttle(fn, delay) {
    let lastCall = 0;
    return function(...args) {
      const now = Date.now();
      if (now - lastCall < delay) return;
      lastCall = now;
      fn.apply(this, args);
    }
  }
})
// tab3
$(function () {
    // 初始化变量
  var moreUrl=$("#tabpro-recom2").attr("data-more-url");
  const $window = $(window);
  const $section = $('#tabpro-recom2');
  const $container = $('#tabpro-recom2 .grid');
  const $products = $('#tabpro-recom2 .grid .grid__item');
  
  let currentIndex = 0;
  const totalProducts = $products.length;
  const initialShow = 8;
  const perShow = 4;
  let isLoading = false;
  currentIndex = initialShow;
    // 滚动事件监听（节流处理）
  $window.on('scroll', throttle(function() {
    if (isLoading || currentIndex >= totalProducts) return;

    // 获取推荐板块位置
    const sectionTop = $section.offset().top;
    const sectionHeight = $section.outerHeight();
    const sectionBottom = sectionTop + sectionHeight;

    // 获取视口位置
    const scrollTop = $window.scrollTop();
    const windowHeight = $window.height();
    const windowBottom = scrollTop + windowHeight;

    // 判断是否进入推荐板块区域
    const isInSection = windowBottom > sectionTop && scrollTop < sectionBottom;

    // 触发显示条件
    if (isInSection && (windowBottom + 100 >= sectionBottom)) {
      showProducts(perShow);
    }
  }, 200));

  // 显示产品函数
  function showProducts(count) {
    isLoading = true;

    // 模拟加载效果
    setTimeout(() => {
      const remaining = totalProducts - currentIndex;
      const showCount = Math.min(count, remaining);

      // 显示对应产品
      $products.slice(currentIndex, currentIndex + showCount).fadeIn(400);
      
      currentIndex += showCount;
      isLoading = false;

      // 全部显示完成
      if (currentIndex >= totalProducts) {
        $("#loadMorebtn2").html('<a class="featured-collection__expand-more featured-collection__expand-more--blank" href="'+moreUrl+'"><span>VIEW ALL</span><svg class="mec-icon featured-collection__expand-more__icon" aria-hidden="true"><use xlink:href="#mec-a-gengduojiantou"></use></svg></a>');
      }
    }, 300);
  }

  // 节流函数
  function throttle(fn, delay) {
    let lastCall = 0;
    return function(...args) {
      const now = Date.now();
      if (now - lastCall < delay) return;
      lastCall = now;
      fn.apply(this, args);
    }
  }
})
// tab4
$(function () {
    // 初始化变量
  var moreUrl=$("#tabpro-recom3").attr("data-more-url");
  const $window = $(window);
  const $section = $('#tabpro-recom3');
  const $container = $('#tabpro-recom3 .grid');
  const $products = $('#tabpro-recom3 .grid .grid__item');
  
  let currentIndex = 0;
  const totalProducts = $products.length;
  const initialShow = 8;
  const perShow = 4;
  let isLoading = false;
  currentIndex = initialShow;
    // 滚动事件监听（节流处理）
  $window.on('scroll', throttle(function() {
    if (isLoading || currentIndex >= totalProducts) return;

    // 获取推荐板块位置
    const sectionTop = $section.offset().top;
    const sectionHeight = $section.outerHeight();
    const sectionBottom = sectionTop + sectionHeight;

    // 获取视口位置
    const scrollTop = $window.scrollTop();
    const windowHeight = $window.height();
    const windowBottom = scrollTop + windowHeight;

    // 判断是否进入推荐板块区域
    const isInSection = windowBottom > sectionTop && scrollTop < sectionBottom;

    // 触发显示条件
    if (isInSection && (windowBottom + 100 >= sectionBottom)) {
      showProducts(perShow);
    }
  }, 200));

  // 显示产品函数
  function showProducts(count) {
    isLoading = true;

    // 模拟加载效果
    setTimeout(() => {
      const remaining = totalProducts - currentIndex;
      const showCount = Math.min(count, remaining);

      // 显示对应产品
      $products.slice(currentIndex, currentIndex + showCount).fadeIn(400);
      
      currentIndex += showCount;
      isLoading = false;

      // 全部显示完成
      if (currentIndex >= totalProducts) {
        $("#loadMorebtn3").html('<a class="featured-collection__expand-more featured-collection__expand-more--blank" href="'+moreUrl+'"><span>VIEW ALL</span><svg class="mec-icon featured-collection__expand-more__icon" aria-hidden="true"><use xlink:href="#mec-a-gengduojiantou"></use></svg></a>');
      }
    }, 300);
  }

  // 节流函数
  function throttle(fn, delay) {
    let lastCall = 0;
    return function(...args) {
      const now = Date.now();
      if (now - lastCall < delay) return;
      lastCall = now;
      fn.apply(this, args);
    }
  }
})
$(function () {
  const homeimgswiper = new Swiper("#pc-show-block .swiper-container", {
                    slidesPerView: 6,
                    slidesPerGroup: 1,
                    spaceBetween: 35,
                    loop:true,
                    autoplay: false,
                    navigation: {
                        nextEl: "#pc-show-block .swiper-button-next",
                        prevEl: "#pc-show-block .swiper-button-prev",
                    }
                });
        
  })
$(function () {
  document.addEventListener('lazyloaded', function(e) {
    const container = e.target.closest('.skeleton-img');
    if (container) {
        container.classList.remove('loading-jw');
    }
  });
})

// jQuery 修改后的代码
$(document).ready(function() {
    const hometabswiper = new Swiper("#tabpro_container.swiper-container", {
                    slidesPerView: 5,
                    centeredSlides:false,
                    observer: true, // 开启动态检查
                  observeParents: true, // 监控父元素变化
                  resizeObserver: true, // 监控尺寸变化
                    slidesPerGroup: 1,
                    spaceBetween: 30,
                    breakpoints: {
                      768: {  
                        slidesPerView: 'auto',
                        spaceBetween: 15
                      },
                      376: {  
                        slidesPerView: 'auto',
                        spaceBetween: 8
                      }
                    },
                    loop:true,
                    autoplay: false,
                    navigation: {
                        nextEl: ".rte-title-con .swiper-button-next"
                    }
//                     on: {
// init: function() { // 初始化后强制刷新
// this.updateSize();
// this.updateSlides();
// this.slideTo(0, 0);
// }
                });
// 缓存元素
const $titles = $('.tab-title');
const $contents = $('.home-tablist_col');
const $navLinks = $('.tab-title a'); // 新增导航链接选择器

// 标题点击事件
$titles.on('click', function(e) {
e.preventDefault();
const index = $(this).data('index');
const $clickedLink = $(this).find('a');

// 切换标题状态
$navLinks.removeClass('active');
$clickedLink.addClass('active');

// 切换对应内容
$contents.removeClass('active').eq(index).addClass('active');

// 滑动到合适位置（优化版）
// const targetSlide = Math.max(0, index - 2);
//   hometabswiper.slideTo(targetSlide);
 });

// 可选：Swiper滑动同步
  // hometabswiper.on('slideChange', function() {
  //   const activeIndex = hometabswiper.activeIndex;
  //   $navLinks.removeClass('active').eq(activeIndex).addClass('active');
  // });
});